import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  title: 'Assess Your Hiring Goals & Business Needs',
  description: 'We analyze your roles, hiring volume, decision criteria, and current workflow to understand where AI will actually create impact.'
}, {
  title: 'AI Opportunity Identification',
  description: 'We pinpoint exactly where AI adds value – resume screening, candidate scoring, interview automation, shortlisting, or workflow automation.'
}, {
  title: 'AI Implementation for Hiring',
  description: 'We implement the right AI tools and logic, tailored to your roles, criteria, and systems (ATS, spreadsheets, email, or custom workflows).'
}, {
  title: 'Refinement & Optimization',
  description: 'We test, tune, and improve the system based on real hiring outcomes – not theory.'
}, {
  title: 'Automate & Manage the Solution',
  description: 'Your AI hiring system runs automatically. We monitor, maintain, and improve it as your hiring needs evolve.'
}];
export function HowItWorks() {
  return <section className="py-16 md:py-24 bg-slate-50" data-id="element-38">
      <div className="max-w-4xl mx-auto px-6" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-41">
            How Our AI Hiring Consulting Works
          </h2>
          <p className="text-lg text-slate-600" data-id="element-42">
            A clear, step-by-step process to transform your hiring from manual
            to automated.
          </p>
        </motion.div>

        <div className="relative" data-id="element-43">
          {/* Vertical Line */}
          <div className="absolute left-[28px] md:left-1/2 top-0 bottom-0 w-0.5 bg-slate-200 transform md:-translate-x-1/2" data-id="element-44" />

          <div className="space-y-12" data-id="element-45">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`relative flex flex-col md:flex-row gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-46">
                {/* Timeline Dot */}
                <div className="absolute left-0 md:left-1/2 w-14 h-14 bg-white border-4 border-blue-500 rounded-full flex items-center justify-center z-10 transform md:-translate-x-1/2 shadow-sm" data-id="element-47">
                  <span className="text-xl font-bold text-blue-700" data-id="element-48">
                    {index + 1}
                  </span>
                </div>

                {/* Content */}
                <div className="ml-20 md:ml-0 md:w-1/2 pt-2" data-id="element-49">
                  <div className={`bg-white p-6 rounded-xl shadow-sm border border-slate-100 ${index % 2 === 0 ? 'md:mr-12' : 'md:ml-12'}`} data-id="element-50">
                    <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-51">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 leading-relaxed" data-id="element-52">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Empty space for the other side */}
                <div className="hidden md:block md:w-1/2" data-id="element-53" />
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}